<div class="table-wrapper" (scroll)="archiveListDataSource.onScroll($event)">
  <table
    mat-table
    [dataSource]="archiveListDataSource"
    class="main-table"
    fixedLayout="true"
    #tableContainer
    >
    <!-- Archive Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="common_name"></span>
      </th>
      <td mat-cell *matCellDef="let archive">
        <span class="flex">
          @switch (archive.resource_type) {
            @case (RESOURCE_TYPE.SESSION) {
              <thumbnail
                [src]="archive.thumbnail_url"
                [fallbackIcon]="'ficon-app-camcorder'"
                [duration]="archive.duration"
                class="media-thumbnail"
                >
              </thumbnail>
            }
            @case (RESOURCE_TYPE.GROUP) {
              <span class="folder">
                <i class="ficon-folder-outline"></i>
              </span>
            }
            @case (RESOURCE_TYPE.ACTIVITY) {
              <span class="activity-icon">
                <i class="ficon-assignment"></i>
              </span>
            }
          }

          <span class="archive-name">
            {{ archive.name }}
            @if (!archive.name?.length) {
              <span>&#8212;</span>
            }
          </span>
        </span>
      </td>
    </ng-container>

    <!-- Owner Column -->
    <ng-container matColumnDef="owner">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="owner"></span>
      </th>
      <td mat-cell *matCellDef="let archive" class="owner-cell">
        @if (!archive.presenters?.length) {
          <span>{{ archive.owner_name }}</span>
        }
        @if (archive.presenters?.length) {
          <div class="name-list">
            <ellipsis-with-count class="ellipsis" [nameList]="getNameList(archive)"></ellipsis-with-count>
          </div>
        }
      </td>
    </ng-container>

    <!-- Archived Date Column -->
    <ng-container matColumnDef="archivedDate">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="archive_table-archived_date"></span>
      </th>
      <td mat-cell *matCellDef="let archive">
        {{ archive.archived_at | date:'mediumDate'}}
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common_actions' | translate"></th>
      <td mat-cell *matCellDef="let archive">
        <button
          type="button"
          class="action-menu-btn icon-btn ficon-app-dots-vertical"
          [attr.aria-label]="'session-list-item_view-options' | translate "
          [attr.data-cy]="'archive-menu-' + archive.resource_type"
          (click)="openMenu($event, archive)">
        </button>
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="displayColumns"
    ></tr>
    <tr
      mat-row
      tabindex="0"
      [attr.aria-label]="archive.name"
      (contextmenu)="openMenu($event, archive)"
      *matRowDef="let row; columns: displayColumns; let archive"
    ></tr>
  </table>

  <menu>
    <archive-menu [archived]="selectedArchive"></archive-menu>
  </menu>
</div>
